class PackNavigation extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleNavigation);
  }

  handleNavigation(event) {
    const button = event.target.closest('button[data-target]');
    if (!button) return;

    const targetId = button.getAttribute('data-target');
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}

customElements.define('pack-navigation', PackNavigation);